import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, onMounted } from "vue";

interface Image {
    id: number;
    urlXXL: string;
    urlSmall: string;
    urlLarge: string;
    orientation: string;
    order: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    images: { type: Array, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { images: Image[] }



const imageHolder = ref();

let isOpen = ref(false);

let viewingId: Ref<number | false> = ref(false);

const handleOpen = (id: number) => {
    if (!id && props.images) {
        viewingId.value = props.images[0].id;
    } else {
        viewingId.value = id;
    }

    isOpen.value = true;

    disableScrolling(true);

    setTimeout(() => {
        const sliderImage: HTMLElement = imageHolder.value.querySelector(`#silder-image-${viewingId.value}`) as HTMLElement;
        const offset: number = sliderImage?.offsetTop || 0;
        imageHolder.value.scrollTo({ top: offset });
    }, 200);
};

const close = () => {
    isOpen.value = false;
    disableScrolling(false);
};

const disableScrolling = (disable: boolean) => {
    const body: HTMLElement | null = document.querySelector("body");

    if (disable) {
        body!.classList.add("overflow-y-hidden");
    } else {
        body!.classList.remove("overflow-y-hidden");
    }
};
setTimeout(function () {
    document.querySelectorAll(".slider-image").forEach((el) => {
        el.addEventListener("click", (event) => {
            // @ts-ignore
            handleOpen(Number(event.target.dataset.nr));
        });
    });
}, 500);

const __returned__ = { props, imageHolder, isOpen, viewingId, handleOpen, close, disableScrolling }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})